import { createAction, props } from '@ngrx/store';
import { IFont } from 'app/models/font';

export const clearAllItems = createAction('[DalHelper] Clear All Fonts');
export const loadItems = createAction('[Module Component] Load Fonts');
export const loadItemsSuccess = createAction('[Font API] Load Fonts Success', props<{ items: IFont[] }>());
export const loadItemsFailure = createAction('[Font API] Load Fonts Failure', props<{ error: any }>());

